import {MatPaginatorIntl} from "@angular/material/paginator";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

export class MatPaginatorLocalization extends MatPaginatorIntl {
	T = Translations;

	constructor(private translateService: TranslateService) {
		super();
		this.translateService.onLangChange.subscribe(() => this.getTranslations());
		this.getTranslations();
	}

	getTranslations() {
		this.translateService
			.get([
				this.T.PAGINATION_ITEMS_PER_PAGE,
				this.T.PAGINATION_FIRST_PAGE,
				this.T.PAGINATION_PREVIOUS_PAGE,
				this.T.PAGINATION_NEXT_PAGE,
				this.T.PAGINATION_LAST_PAGE,
			])
			.subscribe((translation) => {
				this.itemsPerPageLabel = translation[this.T.PAGINATION_ITEMS_PER_PAGE];
				this.firstPageLabel = translation[this.T.PAGINATION_FIRST_PAGE];
				this.previousPageLabel = translation[this.T.PAGINATION_PREVIOUS_PAGE];
				this.nextPageLabel = translation[this.T.PAGINATION_NEXT_PAGE];
				this.lastPageLabel = translation[this.T.PAGINATION_LAST_PAGE];
				this.changes.next();
			});
	}
}
